module.exports = __webpack_public_path__ + "img/app_home4.66b1c51d.png";